/**
 * Created by Kaku.Guo on 2018/11/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generateDisplayImageUrl } from '../../../utils';
import { ImageGallery } from '../../index';

class AssetDetailGallery extends Component {
    constructor(props) {
        super(props);
        this.imageGallery = null;
    }

    render() {
        const {
            data = {}
        } = this.props;
        const {
            keyImages = []
        } = data;
        const galleryData = keyImages.reduce((prev, next) => {
            if (next.type === 'Screenshot') {
                const original = next.url;
                const thumbnail = generateDisplayImageUrl(original, keyImages);
                const originalTitle = next.title;
                prev.push({original, thumbnail, originalTitle});
            }
            return prev;
        }, []);
        return (
            <ImageGallery
                className="asset-details__gallery"
                data={galleryData}
            />
        );
    }
}

AssetDetailGallery.propTypes = {
    data: PropTypes.object
};
export default AssetDetailGallery;
